import { Injectable } from '@angular/core';
import { Http, Headers } from "@angular/http";
import  'rxjs/add/operator/map';
import { Observable } from "rxjs/Observable";
import { Component, Output } from '@angular/core';
import AES from "crypto-js/aes";
import CryptoJS from "crypto-js/crypto-js";






@Injectable()
export class httpService {
  

  
  //url: string = 'http://apisirdee.ceretcar.es/';

  url = 'http://localhost:14000/';

  paginaactual: string = 'albaranes';
  editando: boolean = false;
  pacientes: any;
  pacienteactual: any;
  clienteActual: any;
  albaranActual: any;
  albaranFirma: string = '';
  qrActual: any;
  esQr: boolean = false;
  esInvitado: boolean = false;
  tipoApp: string = 'ALBARAN'; // especificar ALBARAN para albaran o nada para QR

  alerta:any = {
    title: '',
    message: '',
    tipo: '',
    show: false, 
    buttons: false,
    action: ''
  }
  
  //urlApi  = 'http://localhost:11000/';
  //urlCertificado = 'https:/localhost:9999/auth'

  urlApi  = 'https://apicertificado.smartbiometrik.com/';
  urlCertificado = 'https://certificado.smartbiometrik.com:9999/auth';
  urlApiSmart  = 'https://api.smartbiometrik.com/';

  headers: Headers = new Headers();

  constructor(  private _http: Http ) {
    this.setHeaders()
  }



  setHeaders() {

               this.headers.append('Access-Control-Allow-Headers', 'Content-Type');
               this.headers.append("Content-Type", "application/json");
  }

  decodeQr(data) {
    let body = {
      data: data
    }
    return this._http.post(this.urlApi + 'decodeQr', body)
    .map(res => res.json());
  }

  getAlbaranesByQr(qr) {
    let body = {
      qr: qr
    }
    return this._http.post(this.urlApi + 'getAlbaranesByQr', body)
    .map(res => res.json());
  }

  certificado() {
   
    //console.log('asdfas') 
    // return this._http.get('https://certificado.smartbiometrik.com:9999/auth' )
    // return this._http.get('https://certificado.smartbiometrik.com/auth' )
     return this._http.get(this.urlCertificado)
      .map(res => res.json());
  }

  getClientByEmail(email) {
       let url = this.urlApiSmart + '/sb/clientbyemail/' + email;
       return this._http.get(url)
      .map(res => res.json());
  }

  comprobarUsuario(usuario) {
    let body = {
      cliente: usuario
    }
    return this._http.post(this.urlApi + 'getCliente', body)
    .map(res => res.json());
  }

  sendmail(body) {
    
    return this._http.post(this.urlApi + 'email', body)
    .map(res => res.json());
  }

  sendmailfile(body) {
    let endpoint = 'email'
    let fd = new FormData()
    fd.append('from', body.from);
    fd.append('asunto', body.asunto);
    fd.append('mensaje', body.mensaje);
    fd.append('mailTo', body.mailTo)
    if (body.file) {
      fd.append('file', body.file, body.file.name);
      endpoint = 'emailfile';
    }
    
    return this._http.post(this.urlApi + endpoint, fd)
    .map(res => res.json());
  }

  public sendGenericMailWithAttachment(asunto, mensaje, mailTo, link, nombreArchivo, cc?, cco?, firma?) {

    if (firma) {
      mensaje = mensaje + `
                <hr />
                <img src="https://firebasestorage.googleapis.com/v0/b/smartbiometrik-635c1.appspot.com/o/dashboard%2Flogofirma.png?alt=media&token=ff172506-3849-4578-8730-8819b7659a4d" height="100" width="307">
                <p style="text-align: justify; font-size: 10px; font-style: italic;">Este mensaje y los adjuntos pueden contener información confidencial, no estando permitida su comunicación, reproducción o distribución. Si usted no es el destinatario final, le rogamos nos lo comunique y borre el mismo. De conformidad con el que dispone la normativa vigente en protección de datos RGPD y LOPDGDD, le informamos que los datos personales serán tratados bajo la responsabilidad de SMARTBIOMETRIK. Puede ejercer los derechos de acceso, rectificación, portabilidad, supresión, limitación y oposición mandando un mensaje a info@smartbiometrik.com. Si considera que el tratamiento no se ajusta a la normativa vigente, podrá presentar una reclamación ante la autoridad de control en agpd.es. Para más información puede consultar nuestra política de privacidad en https://smartbiometrik.com/politica-privacidad/</p>
                <p style="text-align: justify; font-size: 10px; font-style: italic;">This message and the attachments may contain confidential information, their communication, reproduction or distribution is not allowed. If you are not the final recipient, please let us know and delete the same. In accordance with the provisions of the current RGPD and LOPDGDD data protection regulations, we inform you that personal data will be processed under the responsibility of SMARTBIOMETRIK. You can exercise the rights of access, rectification, portability, deletion, limitation and opposition by sending a message to info@smartbiometrik.com. If you believe that the treatment does not conform to current regulations, you may file a complaint with the control authority at agpd.es. For more information you can consult our privacy policy at https://smartbiometrik.com/politica-privacidad/</p>`;
    }

    let fd = new FormData()
      fd.append('asunto', asunto);
      fd.append('mensaje', mensaje);
      fd.append('mailTo', mailTo)
      fd.append('link', link)
      fd.append('nombreArchivo', nombreArchivo);

    if (cc) {
      fd.append('cc', cc);
    }
    if (cco) {
      fd.append('cco', cco);
    }

    console.log('Enviando email: ', fd)

    return this._http.post('https://api.smartbiometrik.com/sb/sendEmailwithFile', fd)
    .map(res => res.json());
  }

  crearEvento(file) {


      let fd = new FormData();
      fd.append('estado', 'pendiente');
      fd.append('tipo', 'enlace');
      fd.append('cliente','5f073be8f3d49b67ed02dd55' );
      fd.append('titulo', 'Solicitud Certificado SBK');
      fd.append('idPlantilla', '5f101f8e32d23145a7b14b14');
      fd.append('contadorfirmas', '2');
      fd.append('firmaCliente', '1');
      //fd.append('mensaje', evento.mensaje ? evento.mensaje : "");
      fd.append('file', file, file.name + ".pdf");
  

    return this._http.post('https://api.smartbiometrik.com/sb/create/multievent', fd)
    .map(res => res.json());
  }


  registrarCliente(cliente, email, pass) {

    let body = {
      nombre: cliente.subject.CN,
      organizacion: cliente.subject.O ? cliente.subject.O : 'Persona Fisica',
      email: email,
      pass: pass
    }
   
    return this._http.post(this.urlApi + 'createCliente', body)
    .map(res => res.json());
  }

  registrarClienteSmart(cliente) {

    let body = {
      nombre: cliente.nombre,
      organizacion: cliente.organizacion,
      email: cliente.email,
      pass: cliente.cif
    }
   
    return this._http.post(this.urlApi + 'createCliente', body)
    .map(res => res.json());
  }

  updateQr(qr, estado) {

    let body = {
      _id: qr,
      activado: estado
    }
   
    return this._http.post(this.urlApi + 'updateQr', body)
    .map(res => res.json());
  }

  updateAutorizacionQr(qr, estado) {

    let body = {
      _id: qr,
      autorizado: estado
    }
   
    return this._http.post(this.urlApi + 'updateQr', body)
    .map(res => res.json());
  }

  estadoEntregado(id) {

    let body = {
      certificacionid: id
    }
   
    return this._http.get(this.urlApi + 'updateEmailByCertificadoId/' + id)
    .map(res => res.json());
  }


  

  loginManual(email, pass) {

    let body = {
      email: email,
      password: pass
    }
   
    return this._http.post(this.urlApi + 'loginManual', body)
    .map(res => res.json());
  }

  comprobarEmailCliente(email) {

    let body = {
      email: email
    }
   
    return this._http.post(this.urlApi + 'getClienteByEmail', body)
    .map(res => res.json());
  }

  // QR

  crearQr(body) {
   
    return this._http.post(this.urlApi + 'createQr', body)
    .map(res => res.json());
  }

  alive() {
    return this._http.get('https://inbox.smartbiometrik.com/inbox')
       .map( res => res.json())
  }

  getEmails() {
   
    let body = {
      cliente: this.clienteActual._id
    }

    return this._http.post(this.urlApi + 'getEmailsByCliente', body)
    .map(res => res.json());
  }

  createEmail(body) {
   
    return this._http.post(this.urlApi + 'createEmail', body)
    .map(res => res.json());
  }

  getQrs() {
   
    let body = {
      emisor: this.clienteActual._id
    }

    return this._http.post(this.urlApi + 'getQrs', body)
    .map(res => res.json());
  }

  getQr(qr) {
   
    let body = {
      id: qr
    }

    return this._http.post(this.urlApi + 'getQr', body)
    .map(res => res.json());
  }

  crearAlbaran(body) {
    
    return this._http.post(this.urlApi + 'createAlbaran', body)
    .map(res => res.json());
  }

  updateLinkAlbaran(albaran, link) {
   
    let body = {
      _id: albaran, 
      link: link
    }
    return this._http.post(this.urlApi + 'updateAlbaran', body)
    .map(res => res.json());
  }

  public updateAlbaran(albaran) {
   
    return this._http.post(this.urlApi + 'updateAlbaran', albaran)
    .map(res => res.json());
  }

  getAlbaranes() {
   
    let body = {
      emisor: this.clienteActual._id
    }

    return this._http.post(this.urlApi + 'getAlbaranes', body)
    .map(res => res.json());
  }


  getCliente(cliente) {
   
    let body = {
      id: cliente
    }

    return this._http.post(this.urlApi + 'getClienteById', body)
    .map(res => res.json());
  }

  getAlbaran(albaran) {
   
    let body = {
      id: albaran
    }

    return this._http.post(this.urlApi + 'getAlbaran', body)
    .map(res => res.json());
  }


  geteventsdate() {
    let body = { 
      ini: '2020-06-29 00:00:00',
      fin: '2020-07-01 00:00:00',
      tipo: 'plantilla'
    }
    return this._http.post('http://localhost:14000/fb/geteventsdate', body)
    .map( res => res.json());

  }

  getUsuarios() {
    let body = {
      
    }
    return this._http.post('http://localhost:14000/fb/getusuarios', body)
    .map( res => res.json());

  } 

  getUsuarios2() {
    let body = {
      
    }
    return this._http.post('http://localhost:14000/fb/getusuarios2', body)
    .map( res => res.json());

  } 

  updatefirmasevento(evento, firmas) {
    let body = {
      evento: evento,
      firmas: firmas
    
    }
    return this._http.post('http://localhost:14000/fb/updatefirmasevento', body)
    .map( res => res.json());
  }

  updateimagenesusuario(usuario, imagenes, cont) {
    let body = {
      usuario: usuario,
      imagenes: imagenes,
      cont: cont
    
    }
    return this._http.post('http://localhost:14000/fb/updateimagenesusuario', body)
    .map( res => res.json());
  }

  geteventsdate2() {
    let body = {
      ini: '2020-06-28 00:00:00',
      fin: '2020-06-29 00:00:00',
    
    }
    return this._http.post('http://localhost:14000/fb/geteventsdate2', body)
    .map( res => res.json());

  }

  procesarevento(evento) {
    let body = {
      id: evento
    }
    return this._http.post('http://localhost:14000/fb/procesarevento', body)
    .map( res => res.json());

  }

  procesarfirma(url, cont) {
    let body = {
      url: url,
      cont: cont
    }
    return this._http.post('http://localhost:14000/fb/subirimagen', body)
    .map( res => res.json());

  }

  insertarDestinatario(id, email, nombre) {
    let body = {
      destinatario: {
        email: email,
        nombre: nombre
      },
      _id: id
    }
    return this._http.post('http://localhost:11000/insertarDestinatario', body)
    .map( res => res.json());

  }

  insertarEntrega(albaran, entrega ) {
    
    let url = this.urlApi + 'insertarEntrega';

    let body = {
      _id: albaran,
      entrega: entrega
    }

    console.log('insertar: ', body)

    return this._http.post(url, body)
    .map( res => res.json());

  }



  subirfichero(fichero, emisor, albaran, descripcion ) {
    const formData = new FormData(); 
    formData.append('file', fichero, fichero.name); 
    formData.append('emisor', emisor)
    formData.append('albaran', albaran)
    formData.append('descripcion', descripcion)
    let url = this.urlApi + 'subirFirebase';

    console.log(formData)
   

    return this._http.post(url, formData)
               .map( res => res.json());

  }

  miIp() {

    return this._http.get("https://api.ipify.org?format=jsonp&callback=getIP")
       .map( res => { let r = JSON.stringify(res); let r1 = JSON.parse(r); return r1._body.substr(6)})
  }

  geo(ip) {

    // return this._http.get("https://api.ipify.org?format=jsonp&callback=getIP")
    console.log(this.url)
    return this._http.get(this.url + 'sb/stripe/geo/' + ip)
       .map( res => res.json())
  }


 /* 

  cargarPacientes() {
    return this._http.get(this.url + 'paciente/getPacientes')
               .map( res => res.json());
  }

  grabarPaciente(paciente) {
    let url = this.url + 'paciente/create';
    
    return this._http.post(url, paciente)
               .map( res => res.json());

  }

  updatePaciente(paciente) {
    let url = this.url + 'paciente/update';

    return this._http.post(url, paciente)
               .map( res => res.json());

  }


 
    public uploadImage(formdata: any ) {
        let url: string = 'https://www.grupovalenzuela.com/pruebas/fileUpload.php';
        return this._http.post(url, formdata)
            .map(res => {

             

             });


  }

 

  hacer_login(user, pass){
    let url = this.url + 'paciente/user/login';
    let body = {
      usuario: user,
      password: pass
    }

    return this._http.post(url, body)
               .map( res => res.json());


  }

 

  enviarCorreo() {

    return this._http.get('')
               .map( res => res.json())

  }
  */

 public encryptData(contenido, key): string {
  //Primero comprimimos el JSON, luego encriptamos, y por ultimo codificamos para enviar.
  let encriptado = encodeURIComponent(AES.encrypt(JSON.stringify(contenido), key));
  return encriptado;
}

/**
* Función para desencriptar datos.
* @param contenido 
* @param key 
*/
public decryptData(contenido, key): any {
  //Primero decodificamos, luego desencriptamos el contenido, y por último parseamos la información a JSON.
  try {
    var bytes = AES.decrypt(decodeURIComponent(contenido), key)
    let res = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    return res;
  } catch(e) {
    return 'bad';
  }
  
}

showAlerta(message, title, tipo, buttons?, action?) {
  this.alerta.title = title;
  this.alerta.message = message;
  this.alerta.tipo = tipo;
  this.alerta.show = true;
  this.alerta.buttons = buttons ? true : false;
  this.alerta.action = action ? action : ''

}



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/components/body.service.ts